<template>
<div>
    <ModalEditScenario></ModalEditScenario>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ModalEditScenario from '@/components/ui/ModalEditScenario'

export default {
  components: {
    ModalEditScenario
  },
}
</script>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/DetailByParts.vue